"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExamSecondSemester = exports.isExamStandard = exports.isExamOnly = exports.EXAM_SS = exports.EXAM_STANDARD = exports.EXAM_ONLY = void 0;
const EXAM_ONLY = 'EO';
exports.EXAM_ONLY = EXAM_ONLY;
const EXAM_STANDARD = 'S_FY';
exports.EXAM_STANDARD = EXAM_STANDARD;
const EXAM_SS = 'S_SS';
exports.EXAM_SS = EXAM_SS;

const isExamOnly = function (_ref) {
  let sectionType = _ref.sectionType;
  return sectionType === EXAM_ONLY;
};

exports.isExamOnly = isExamOnly;

const isExamStandard = function (_ref2) {
  let sectionType = _ref2.sectionType;
  return sectionType === EXAM_STANDARD;
};

exports.isExamStandard = isExamStandard;

const isExamSecondSemester = function (_ref3) {
  let sectionType = _ref3.sectionType;
  return sectionType === EXAM_SS;
};

exports.isExamSecondSemester = isExamSecondSemester;